import { createContext } from 'react';
export const StepContext = createContext(undefined);
